// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cb9689c1","667":"d8032892","977":"e9b4ba06"}[chunkId] + ".chunk.js";
};